module.exports = __webpack_public_path__ + "img/bn-logo-dark.68c2dcf9.svg";